import { Routes } from '@angular/router';
import { AuthGuardService } from '@services/index';
import { PollLauncherComponent } from './polls/components/index';
import { PageNotFoundComponent } from './not-found.component';
import { EulaComponent } from './eula/eula.component';
var ɵ0 = {
    permitted: ['admin']
}, ɵ1 = {
    permitted: ['student']
}, ɵ2 = {
    permitted: ['student']
};
var routes = [
    {
        path: 'admin',
        loadChildren: 'app/admin/admin.module#AdminModule',
        canActivateChild: [AuthGuardService],
        data: ɵ0
    },
    {
        path: 'launcher',
        component: PollLauncherComponent,
        pathMatch: 'full',
        canActivate: [AuthGuardService],
        data: ɵ1
    },
    {
        path: 'poll',
        loadChildren: 'app/polls/polls.module#PollsModule',
        canActivateChild: [AuthGuardService],
        data: ɵ2
    },
    {
        path: 'eula',
        component: EulaComponent,
    },
    {
        path: 'forbidden',
        component: PageNotFoundComponent,
    },
    {
        path: '**',
        component: PageNotFoundComponent,
        canActivate: [AuthGuardService]
    }
];
var RouteModule = /** @class */ (function () {
    function RouteModule() {
    }
    return RouteModule;
}());
export { RouteModule };
export { ɵ0, ɵ1, ɵ2 };
